/**
 * Global Bear Paw Cursor Handler
 * --------------------------------------------------------------------------
 * Handles global clickable elements while excluding components that have
 * their own individual cursor (such as .hero-product-teaser).
 */

(function () {
    const CLICKABLE_SELECTOR = 'a, button, [role="button"], input, select, textarea, label, .tab, .clickable, details summary, [tabindex]:not([tabindex="-1"]), [onclick], [data-action], .btn, .nav-menu a, .social-btn, .qty-btn, .icon-tabs__tab, .logo-tab__tab, .product-grid .product-card, .resource-list__item .product-card';

    // Components that have their own cursor and should be ignored by the global cursor
    const EXCLUDED_CONTAINERS = '.hero-product-teaser, [data-no-global-cursor], .theme-video__media-wrapper, .custom-filter__item--checkbox, .footer-content .menu__details summary, #LocalizationForm .language-selector select, .acp-widget-large, .asw-menu-btn, .email-signup-block input';
    // const EXCLUDED_CONTAINERS = '.hero-product-teaser, [data-no-global-cursor]';

    function initPawCursor() {

        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            return;
        }

        let pawCursor = document.querySelector('.paw-cursor-global');

        if (!pawCursor) {
            return;
        }

        let isTicking = false;
        let mouseX = 0;
        let mouseY = 0;
        let isVisible = true;

        // Use IntersectionObserver to pause when body is off-screen
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                isVisible = entry.isIntersecting;
            });
        });
        observer.observe(document.body);

        document.addEventListener('mousemove', function (e) {
            if (!isVisible) return;
            
            mouseX = e.clientX;
            mouseY = e.clientY;
            
            if (!isTicking) {
                window.requestAnimationFrame(function () {
                    pawCursor.style.left = mouseX + 'px';
                    pawCursor.style.top = mouseY + 'px';
                    isTicking = false;
                });
                isTicking = true;
            }
        }, { passive: true });

        document.addEventListener('mouseover', function (e) {
            // Do NOT activate global cursor inside single-component sections
            if (e.target.closest(EXCLUDED_CONTAINERS)) {
                pawCursor.classList.remove('active');
                return;
            }

            const clickable = e.target.closest(CLICKABLE_SELECTOR);
            if (clickable) {
                pawCursor.classList.add('active');
            }
        });

        document.addEventListener('mouseout', function (e) {
            if (e.target.closest(EXCLUDED_CONTAINERS)) {
                pawCursor.classList.remove('active');
                return;
            }

            const clickable = e.target.closest(CLICKABLE_SELECTOR);
            if (clickable) {
                if (!clickable.contains(e.relatedTarget)) {
                    pawCursor.classList.remove('active');
                    pawCursor.classList.remove('clicking');
                }
            }
        });

        document.addEventListener('mousedown', function (e) {
            if (e.target.closest(EXCLUDED_CONTAINERS)) return;
            const clickable = e.target.closest(CLICKABLE_SELECTOR);
            if (clickable) {
                pawCursor.classList.add('clicking');
            }
        });

        document.addEventListener('mouseup', function () {
            pawCursor.classList.remove('clicking');
        });

        document.addEventListener('mouseleave', function () {
            pawCursor.classList.remove('active');
            pawCursor.classList.remove('clicking');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPawCursor);
        document.querySelectorAll(
            '.product-grid .product-card, .resource-list__item .product-card'
        ).forEach(function (card) {
            card.addEventListener('click', function () {
                this.style.pointerEvents = 'none';
            });
        });
    } else {
        initPawCursor();
    }
})();
